import type { FC, ReactNode } from 'react'
import type { TagDetailPageProps } from '@/lib/tag-pages'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { tagDetailProps } from '@/lib/tag-pages'
import TagDetailView from '@/components/kb/tag-detail-view'

const PlacePage: FC<TagDetailPageProps> = ({ data }): ReactNode => {
    const description = data.tag.description ?? `Every vastu remedy, principle and answer from the Geo Vastu courses for ${data.tag.name}.`

    return (
        <Layout>
            <Seo title={data.tag.name} description={description} />

            <TagDetailView data={data} />
        </Layout>
    )
}

export const getServerSideProps = tagDetailProps('place')

export default PlacePage
